/* Code generated with AutoHTML Plugin for Figma */
import { LoginEmailRequest } from "@project/shared-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { v4 as uuidv4 } from "uuid";
import {
  LoginClientEmailAPI,
  LoginClientEmailCodeAPI,
} from "../../api/LoginAPI";
import { Button } from "../../components/button/button";
import { Input } from "../../components/inputs/Input";
import { Loader } from "../../components/Loader/Loader";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import {
  _aligeText,
  _colorText,
  _size,
  _sizeHeading,
  _sizeText,
  _typeInput,
} from "../../core/core";
import { sendMetrics } from "../../hooks/analitics/sendMetrics";
import { useLocalStorage } from "../../hooks/useLocalStoreg";
import "./Login.css";

export const Login = ({ ...props }) => {
  const [email, setEmail] = useLocalStorage("email", "");
  const [global_id] = useLocalStorage("global_id", uuidv4());
  const [token, setToken] = useLocalStorage("token", "");
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isCode, setIsCode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailClick = async () => {
    try {
      setIsLoading(true);
      const data_featch = { email, global_id } as LoginEmailRequest;
      const response = await LoginClientEmailAPI(data_featch); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг

      setIsCode(true);
      setIsLoading(false);
      sendMetrics("reachGoal", "new_auth_email");
    } catch (error) {
      sendMetrics("reachGoal", "error_email");
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  const onKeyDownCode = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleCodeClick({ email, code });
    }
  };
  const onKeyDownEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleEmailClick();
    }
  };
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const [email, code] = location.hash.split("=");
      console.log(email, code);
      if (email && code) {
        setEmail(email.replace("#", ""));
        setCode(code);
        handleCodeClick({ email: email.replace("#", ""), code });
      }
    }
  }, [location.hash]);
  const handleCodeClick = async ({ email, code }: { email: string; code: string }) => {
    try {
      sendMetrics("reachGoal", "new_auth_code");
      const data_featch = {
        email: email,
        code: code,
        global_id,
      } as LoginEmailRequest;
      setIsLoading(true);
      const response = await LoginClientEmailCodeAPI(data_featch); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг
      if (response.error) {
        setError(response.error);
      }
      console.log(response);
      setToken(response.token);
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (typeof window !== "undefined") {
        window.location.href = response.url;
      }
      setIsLoading(false);
    } catch (error) {
      sendMetrics("reachGoal", "error_code");
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  return (
    <div className="login">
      <div className="login-body">
        <div className="login-header">
          <Title type={_sizeHeading.h2_2} is_h1>
            Авторизация
          </Title>
          <Text
            size={_sizeText.hmp}
            aligeText={_aligeText.center}
            color={_colorText.black}
          >
            {isCode
              ? `Укажите код, отправленный на ${email} Проверьте спам.`
              : "Укажите почту, мы отправим вам код подтверждения"}
          </Text>
        </div>
        {isLoading ? (
          <Loader isLoading></Loader>
        ) : (
          <>
            {isCode ? (
              <div className="login-main">
                <Input
                  type={_typeInput.number}
                  value={code}
                  setValue={setCode}
                  onKeyDown={onKeyDownCode}
                  error={error}
                  label={"Укажите код"}
                ></Input>
                <Button size={_size.M} width={"100%"} onClick={() => handleCodeClick({ email, code })}>
                  Войти
                </Button>
              </div>
            ) : (
              <div className="login-main">
                <Input
                  value={email}
                  setValue={setEmail}
                  onKeyDown={onKeyDownEmail}
                  label={"Укажите почту"}
                ></Input>
                <Button
                  size={_size.M}
                  width={"100%"}
                  onClick={handleEmailClick}
                >
                  Получить код
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
